{
  "eyebrow": "Alege-ți planul",
  "title": "Planul potrivit pentru felul în care lucrează echipa ta.",
  "sub": "30 de zile de încercare gratuită la orice plan. Fără card. Anulează oricând.",
  "bill": {
    "month": "Lunar",
    "year": "Anual",
    "save": "Economisește 15%"
  },
  "fam": {
    "time": "Timp și operațiuni",
    "project": "Proiecte și control al costurilor"
  },
  "compare": "Compară toate funcționalitățile",
  "compareHide": "Ascunde comparația",
  "included": "Inclus",
  "select": "Alege {{plan}}",
  "selected": "Selectat",
  "recommended": "Cel mai popular",
  "pricePerMonth": "/ utilizator / lună",
  "pricePerYear": "/ utilizator / an",
  "base": "bază / lună",
  "admins": "2 administratori incluși",
  "continueCta": "Continuă cu {{plan}}",
  "continuePick": "Alege un plan pentru a continua",
  "catalogError": "Catalog de prețuri indisponibil. Reîncearcă pentru a încărca cele mai noi prețuri.",
  "plans": {
    "timeBasic": "Time Basic",
    "timePro": "Time Pro",
    "projectBasic": "Project Basic",
    "projectPro": "Project Pro",
    "timeBasicBest": "Conformitate și pontaj simplu",
    "timeProBest": "Operațiuni de echipă",
    "projectBasicBest": "Proiecte și control al costurilor",
    "projectProBest": "Management avansat de proiect",
    "feat": {
      "timeBasic": {
        "timeTracking": "Înregistrarea timpului",
        "absencesHolidays": "Absențe și concedii",
        "transport": "Jurnale de transport",
        "workLocations": "Locuri de muncă și GPS",
        "mobileApp": "Aplicație mobilă pentru lucrătorii de teren"
      },
      "timePro": {
        "everythingTime": "Tot ce e în Time Basic",
        "overtime": "Înregistrarea orelor suplimentare",
        "scheduling": "Programarea schimburilor",
        "documents": "Documente ale angajaților",
        "officeOps": "Funcții de birou (jurnal activitate, corecții)",
        "addonsAvailable": "Add-on-uri disponibile: urmărirea proiectelor, VTT",
        "internalMessaging": "Mesagerie internă (chat de companie)"
      },
      "projectBasic": {
        "everythingTime": "Tot ce e în Time Basic",
        "projects": "Proiecte cu control al costurilor",
        "extras": "Lucrări și materiale suplimentare",
        "subcontractors": "Gestionarea subcontractanților",
        "checkInOut": "Check-in / check-out al lucrătorilor",
        "internalMessaging": "Mesagerie internă (chat de companie)"
      },
      "projectPro": {
        "everythingAll": "Tot ce e în Time Pro + Project Basic",
        "projectTransport": "Transport pe proiect",
        "fullSuite": "Suită completă de productivitate",
        "prioritySupport": "Asistență prioritară",
        "internalMessaging": "Mesagerie internă (chat de companie)"
      }
    },
    "timeZero": "Time Zero"
  },
  "comparison": {
    "title": "Comparați toate funcțiile",
    "subtitle": "Tot ce include fiecare plan, unul lângă altul.",
    "cat": {
      "timeAttendance": "Timp & prezență",
      "projectCost": "Proiect & control al costurilor",
      "support": "Asistență"
    },
    "val": {
      "upTo4": "Până la 4",
      "unlimited": "Nelimitat",
      "soon": "În curând",
      "optional": "Opțional",
      "years5": "5 ani",
      "years10": "10 ani"
    },
    "row": {
      "mobileDesktop": "Aplicație mobilă & desktop",
      "gpsCheckin": "Pontaj cu o atingere prin GPS",
      "holidayAbsenceOvertime": "Concediu, absențe & ore suplimentare",
      "teamMembers": "Membrii echipei",
      "workLocations": "Locații de lucru",
      "registrationsPerMonth": "Înregistrări / utilizator / lună",
      "irregularMap": "Pontaj neregulat pe hartă",
      "expenseManagement": "Gestionarea cheltuielilor",
      "employeeDocuments": "Documente angajați",
      "openApi": "API deschis",
      "navigation": "Navigare către șantiere",
      "projectManagement": "Management de proiect (buget)",
      "subprojects": "Subproiecte",
      "subcontractorManagement": "Gestionarea subcontractanților",
      "extraWorkMaterials": "Lucrări & materiale suplimentare",
      "transportProjects": "Transport legat de proiecte",
      "fullSuite": "Suită completă de productivitate",
      "prioritySupport": "Asistență prioritară",
      "languages12": "Disponibil în 12 limbi",
      "manualTransport": "Distanță de transport manuală",
      "reportsExcel": "Rapoarte și export Excel",
      "frontendLocations": "Locații create de utilizatorii aplicației",
      "checkInWork": "Check-in/out@work (Belgia)",
      "vehicleTracking": "Vehicle Track & Trace",
      "projectDescriptions": "Descrieri și imagini de proiect",
      "dataStorage": "Stocarea datelor",
      "schedulingPlanning": "Planificare",
      "messagingNotifications": "Mesagerie · Notificări"
    }
  }
}
